// extracted by mini-css-extract-plugin
export default {"img":"ImageViewer_img__DXJTD","pdf":"ImageViewer_pdf__P8DWU"};